import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const url = (path: string) => `${environment.server.apiURL}/Hospitality${path}`;
const json = { "Content-Type": "application/json" };

/** Hospitality packages, and which games they run at. */
export const HospitalityService = {
	getPackages: async () => await FetchInterceptor(url("/Packages"), {headers: json, method: "GET"}),
	addPackage: async (data: any) => await FetchInterceptor(url("/Packages"), {body: JSON.stringify(data), headers: json, method: "POST"}),
	updatePackage: async (id: number, data: any) => await FetchInterceptor(url(`/Packages/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	removePackage: async (id: number) => await FetchInterceptor(url(`/Packages/${id}`), {headers: json, method: "DELETE"}),
	getFixtures: async (id: number) => await FetchInterceptor(url(`/Packages/${id}/Fixtures`), {headers: json, method: "GET"}),
	setFixtures: async (id: number, data: any) => await FetchInterceptor(url(`/Packages/${id}/Fixtures`), {body: JSON.stringify(data), headers: json, method: "POST"})
};
